import { BadgeId, QuestionId, QuizModuleId } from "@common";
import React, { useState } from "react";

interface TestStoreContextType {
  referredToQuiz: QuizModuleId | undefined;
  referredToQuestion: QuestionId | undefined;
  confettiIsRunning: boolean;
  minimizedQuiz: boolean;
  thumbsDownIsRunning: boolean;
  starAnimIsRunning: boolean;
  badgeIdOfCurrentTest?: BadgeId;
  quizStarted: boolean;
  setBadgeIdOfCurrentTest: React.Dispatch<React.SetStateAction<BadgeId | undefined>>;
  setReferredToQuiz: React.Dispatch<React.SetStateAction<QuizModuleId | undefined>>;
  setReferredToQuestion: React.Dispatch<React.SetStateAction<QuestionId | undefined>>;
  setConfettiIsRunning: React.Dispatch<React.SetStateAction<boolean>>;
  setMinimizedQuiz: React.Dispatch<React.SetStateAction<boolean>>;
  setThumbsDownIsRunning: React.Dispatch<React.SetStateAction<boolean>>;
  setStarAnimIsRunning: React.Dispatch<React.SetStateAction<boolean>>;
  setQuizStarted: React.Dispatch<React.SetStateAction<boolean>>;
}

export const TestStoreContext = React.createContext<TestStoreContextType>({
  referredToQuiz: undefined,
  referredToQuestion: undefined,
  confettiIsRunning: false,
  minimizedQuiz: false,
  thumbsDownIsRunning: false,
  starAnimIsRunning: false,
  quizStarted: false,
  setBadgeIdOfCurrentTest: () => null,
  setReferredToQuiz: () => null,
  setReferredToQuestion: () => null,
  setConfettiIsRunning: () => null,
  setMinimizedQuiz: () => null,
  setThumbsDownIsRunning: () => null,
  setStarAnimIsRunning: () => null,
  setQuizStarted: () => null,
});

export const TestStoreProvider: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [badgeIdOfCurrentTest, setBadgeIdOfCurrentTest] = useState<BadgeId>();
  const [referredToQuiz, setReferredToQuiz] = useState<QuizModuleId | undefined>(undefined);
  const [referredToQuestion, setReferredToQuestion] = useState<QuestionId | undefined>(undefined);
  const [confettiIsRunning, setConfettiIsRunning] = useState<boolean>(false);
  const [thumbsDownIsRunning, setThumbsDownIsRunning] = useState<boolean>(false);
  const [starAnimIsRunning, setStarAnimIsRunning] = useState<boolean>(false);
  const [minimizedQuiz, setMinimizedQuiz] = useState<boolean>(false);
  const [quizStarted, setQuizStarted] = useState<boolean>(false);

  return (
    <TestStoreContext.Provider
      value={{
        referredToQuiz,
        setReferredToQuiz,
        confettiIsRunning,
        setConfettiIsRunning,
        thumbsDownIsRunning,
        setThumbsDownIsRunning,
        badgeIdOfCurrentTest,
        setBadgeIdOfCurrentTest,
        starAnimIsRunning,
        setStarAnimIsRunning,
        referredToQuestion,
        setReferredToQuestion,
        minimizedQuiz,
        setMinimizedQuiz,
        quizStarted,
        setQuizStarted,
      }}
    >
      {children}
    </TestStoreContext.Provider>
  );
};
